<span class="m-footer__copyright">
    {{ year }} &copy;
    <a href="https://medifit.si" target="_blank" class="m-link">Medifit d.o.o</a>
    v{{ version }}
</span>
